var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 223,
    viewBox: "0 0 188 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 0.30957H0.263672V222.728H187.77V0.30957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 222.079H0.263672V222.727H187.97V222.079Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 184.84H0.263428V185.488H187.97V184.84Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 147.6H0.263428V148.248H187.97V147.6Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 110.361H0.263428V111.009H187.97V110.361Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 73.1201H0.263428V73.7681H187.97V73.1201Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 35.8809H0.263428V36.5289H187.97V35.8809Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 0.30957H187.432V222.403H187.97V0.30957Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.556 0.30957H156.018V222.403H156.556V0.30957Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.144 0.30957H124.606V222.403H125.144V0.30957Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7318 0.30957H93.1936V222.403H93.7318V0.30957Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3185 0.30957H61.7803V222.403H62.3185V0.30957Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9066 0.30957H30.3684V222.403H30.9066V0.30957Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 222.239H0.263428V222.565H187.97V222.239Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 212.932H0.263428V213.257H187.97V212.932Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 203.62H0.263672V203.946H187.97V203.62Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 194.313H0.263672V194.639H187.97V194.313Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 185H0.263428V185.326H187.97V185Z",
    fill: "#E0E0E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 175.692H0.263428V176.018H187.97V175.692Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 166.381H0.263672V166.707H187.97V166.381Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 157.072H0.263672V157.398H187.97V157.072Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 147.761H0.263672V148.087H187.97V147.761Z",
    fill: "#E0E0E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 138.45H0.263428V138.776H187.97V138.45Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 129.143H0.263428V129.468H187.97V129.143Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 119.833H0.263672V120.159H187.97V119.833Z",
    fill: "#EBEBEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 110.523H0.263672V110.849H187.97V110.523Z",
    fill: "#E0E0E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 101.211H0.263428V101.537H187.97V101.211Z",
    fill: "#EBEBEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 91.9033H0.263428V92.2291H187.97V91.9033Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 82.5938H0.263672V82.9196H187.97V82.5938Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 73.2842H0.263672V73.61H187.97V73.2842Z",
    fill: "#E0E0E0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 63.9717H0.263428V64.2975H187.97V63.9717Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 54.6641H0.263428V54.9899H187.97V54.6641Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 45.3545H0.263428V45.6803H187.97V45.3545Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 36.043H0.263672V36.3688H187.97V36.043Z",
    fill: "#E0E0E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 26.7324H0.263672V27.0582H187.97V26.7324Z",
    fill: "#EBEBEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 17.4238H0.263428V17.7496H187.97V17.4238Z",
    fill: "#EBEBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 8.11719H0.263428V8.44301H187.97V8.11719Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.836 0.30957H187.566V222.403H187.836V0.30957Z",
    fill: "#EBEBEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M179.981 0.30957H179.711V222.403H179.981V0.30957Z",
    fill: "#EBEBEB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M172.128 0.30957H171.858V222.403H172.128V0.30957Z",
    fill: "#EBEBEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M164.274 0.30957H164.005V222.403H164.274V0.30957Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.422 0.30957H156.153V222.403H156.422V0.30957Z",
    fill: "#E0E0E0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.569 0.30957H148.3V222.403H148.569V0.30957Z",
    fill: "#EBEBEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M140.716 0.30957H140.446V222.403H140.716V0.30957Z",
    fill: "#EBEBEB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M132.863 0.30957H132.593V222.403H132.863V0.30957Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M125.01 0.30957H124.74V222.403H125.01V0.30957Z",
    fill: "#E0E0E0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.158 0.30957H116.888V222.403H117.158V0.30957Z",
    fill: "#EBEBEB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M109.305 0.30957H109.035V222.403H109.305V0.30957Z",
    fill: "#EBEBEB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.451 0.30957H101.182V222.403H101.451V0.30957Z",
    fill: "#EBEBEB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5982 0.30957H93.3286V222.403H93.5982V0.30957Z",
    fill: "#E0E0E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7449 0.30957H85.4753V222.403H85.7449V0.30957Z",
    fill: "#EBEBEB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8907 0.30957H77.6211V222.403H77.8907V0.30957Z",
    fill: "#EBEBEB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0379 0.30957H69.7683V222.403H70.0379V0.30957Z",
    fill: "#EBEBEB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1844 0.30957H61.9148V222.403H62.1844V0.30957Z",
    fill: "#E0E0E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3314 0.30957H54.0618V222.403H54.3314V0.30957Z",
    fill: "#EBEBEB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4793 0.30957H46.2097V222.403H46.4793V0.30957Z",
    fill: "#EBEBEB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6263 0.30957H38.3567V222.403H38.6263V0.30957Z",
    fill: "#EBEBEB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.773 0.30957H30.5034V222.403H30.773V0.30957Z",
    fill: "#E0E0E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9197 0.30957H22.6501V222.403H22.9197V0.30957Z",
    fill: "#EBEBEB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0667 0.30957H14.7971V222.403H15.0667V0.30957Z",
    fill: "#EBEBEB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21369 0.30957H6.94409V222.403H7.21369V0.30957Z",
    fill: "#EBEBEB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 222.728C187.77 222.728 187.762 222.37 187.757 221.681C187.754 220.985 187.75 219.962 187.744 218.614C187.737 215.905 187.728 211.902 187.717 206.681C187.703 196.237 187.683 180.934 187.657 161.462C187.629 122.548 187.589 66.9757 187.541 0.311391L187.769 0.581908C133.271 0.593931 68.9288 0.608358 0.280736 0.623988H0.262517L0.526025 0.311391C0.512848 81.7591 0.500682 158.086 0.490546 222.728L0.262517 222.458C56.47 222.515 103.318 222.562 136.123 222.596C152.538 222.626 165.438 222.65 174.242 222.667C178.643 222.68 182.018 222.691 184.3 222.698C185.437 222.705 186.299 222.71 186.886 222.714C187.468 222.719 187.77 222.728 187.77 222.728C187.77 222.728 187.485 222.739 186.912 222.744C186.332 222.748 185.477 222.752 184.351 222.76C182.079 222.767 178.718 222.778 174.337 222.791C165.545 222.808 152.663 222.832 136.27 222.862C103.431 222.895 56.5318 222.942 0.263507 223H0.0354787V222.729C0.025343 158.086 0.0131764 81.7591 0 0.312597V0H0.264528H0.282778C68.9309 0.0156297 133.273 0.030057 187.771 0.0420798H188V0.312597C187.952 67.0479 187.912 122.68 187.883 161.637C187.858 181.082 187.838 196.365 187.824 206.794C187.811 211.992 187.803 215.979 187.797 218.675C187.791 220.011 187.787 221.025 187.784 221.714C187.778 222.39 187.77 222.728 187.77 222.728Z",
    fill: "#E0E0E0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5649 189.277L69.4749 151.438L67.6139 150.026L51.1899 171.672C52.1249 172.729 52.2679 174.299 51.3829 175.465C50.3739 176.794 48.4789 177.054 47.1499 176.046C45.8209 175.037 45.5609 173.142 46.5699 171.813C47.4559 170.646 49.0059 170.362 50.2749 170.978L66.6999 149.333L64.9439 148L29.4409 165.065C39.4929 173.615 32.8909 184.47 32.8909 184.47L42.9979 192.277C50.7029 182.122 62.5649 189.277 62.5649 189.277Z",
    fill: "#211C52"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27.946 183.526L44.687 196.439L39.833 203.043L23 189.543L27.946 183.526Z",
    fill: "#211C52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3002_8645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5 129C83.7473 129 75 120.253 75 109.5C75 98.7473 83.7473 90 94.5 90C105.253 90 114 98.7473 114 109.5C114 120.253 105.253 129 94.5 129ZM94.5 92.4375C85.0913 92.4375 77.4375 100.091 77.4375 109.5C77.4375 118.909 85.0913 126.562 94.5 126.562C103.909 126.562 111.562 118.909 111.562 109.5C111.562 100.091 103.909 92.4375 94.5 92.4375Z",
    fill: "#6150E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.031 110.719H85.9688C85.296 110.719 84.75 110.173 84.75 109.5C84.75 108.827 85.296 108.281 85.9688 108.281H103.031C103.704 108.281 104.25 108.827 104.25 109.5C104.25 110.173 103.704 110.719 103.031 110.719Z",
    fill: "#6150E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 119.25C93.8272 119.25 93.2812 118.704 93.2812 118.031V100.969C93.2812 100.296 93.8272 99.75 94.5 99.75C95.1728 99.75 95.7188 100.296 95.7188 100.969V118.031C95.7188 118.704 95.1728 119.25 94.5 119.25Z",
    fill: "#6150E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3002_8645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(75 90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateCard);
export default __webpack_public_path__ + "static/media/templateCard.df4527302286fa9f8160a4be45358352.svg";
export { ForwardRef as ReactComponent };